
import clsx from 'clsx';

export interface SurfaceProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: 'none' | 'sm' | 'md' | 'lg';
  shadow?: boolean;
  border?: boolean;
}

const paddingMap: Record<NonNullable<SurfaceProps['padding']>, string> = {
  none: '',
  sm: 'p-3 sm:p-4',
  md: 'p-4 sm:p-6',
  lg: 'p-6 sm:p-8',
};

/**
 * Lightweight wrapper that applies consistent rounded corners, background, and spacing for cards.
 */
export function Surface({
  className,
  padding = 'md',
  shadow = true,
  border = true,
  children,
  ...rest
}: SurfaceProps) {
  return (
    <div
      className={clsx(
        'rounded-2xl bg-white dark:bg-gray-800',
        shadow && 'shadow-sm shadow-gray-200/70 dark:shadow-none',
        border && 'ring-1 ring-gray-100 dark:ring-1 dark:ring-gray-700/60',
        paddingMap[padding],
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
